<template>
  <div>
    <AdminNav />
    <div class="page">
      <h2 class="page-title">Gestion journées</h2>

      <div class="card">
        <div class="table-wrap"><table class="table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Commerçant</th>
              <th>Ville</th>
              <th>CA fidélisé</th>
              <th>CA saisi</th>
              <th>Dépenses</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="j in journees" :key="j.id">
              <td class="date">{{ formatDate(j.date) }}</td>
              <td><strong>{{ j.nom_enseigne }}</strong></td>
              <td>{{ j.ville || '—' }}</td>
              <td>{{ formatEuro(j.ca_fidelise) }}</td>
              <td>{{ j.ca_total_saisi ? formatEuro(j.ca_total_saisi) : '—' }}</td>
              <td>{{ formatEuro(j.total_depenses) }}</td>
              <td>
                <span class="badge" :class="j.statut === 'cloture' ? 'badge-green' : 'badge-orange'">
                  {{ j.statut === 'cloture' ? 'Clôturé' : 'En cours' }}
                </span>
              </td>
              <td>
                <button class="btn-action delete" @click="supprimer(j.id)" title="Supprimer">🗑️</button>
              </td>
            </tr>
          </tbody>
        </table></div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminNav from '../../components/AdminNav.vue'
import adminApi from '../../adminApi'

export default {
  name: 'AdminJournees',
  components: { AdminNav },
  data() { return { journees: [] } },
  methods: {
    formatEuro(v) { return Number(v||0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }) },
    formatDate(d) { return new Date(d).toLocaleDateString('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' }) },
    async charger() {
      try { const res = await adminApi.get('/journees'); this.journees = res.data } catch {}
    },
    async supprimer(id) {
      if (!confirm('Supprimer cette journée et toutes ses transactions ? Action irréversible.')) return
      try { await adminApi.delete(`/journees/${id}`); await this.charger() } catch {}
    }
  },
  mounted() { this.charger() }
}
</script>

<style scoped>
.page { padding: 24px; max-width: 1200px; margin: 0 auto; }
.page-title { font-size: 22px; font-weight: 700; margin-bottom: 20px; }
.card { background: white; border-radius: 14px; padding: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
.table { width: 100%; min-width: 600px; border-collapse: collapse; font-size: 14px; }
.table th { text-align: left; padding: 10px 12px; font-size: 12px; color: #718096; border-bottom: 2px solid #e2e8f0; white-space: nowrap; }
.table td { padding: 10px 12px; border-bottom: 1px solid #f0f0f0; vertical-align: middle; }
.table tr:hover td { background: #f7fafc; }
.date { font-size: 12px; color: #718096; white-space: nowrap; }
.badge { padding: 3px 10px; border-radius: 20px; font-size: 12px; font-weight: 600; }
.badge-green { background: #c6f6d5; color: #22543d; }
.badge-orange { background: #feebc8; color: #7b341e; }
.btn-action { background: none; border: 1.5px solid #e2e8f0; border-radius: 8px; padding: 5px 9px; cursor: pointer; font-size: 13px; }
.btn-action:hover { background: #fff5f5; border-color: #fc8181; }
</style>
